import React from 'react';

const SwitchButton = ({ className = '', buttons, setActiveButton, activeButton }) => {
  const onButtonClick = item => {
    setActiveButton(item.type);
  };

  return (
    <div className={`switch-buttons p-1 bg-gray-light rounded-6 overflow-hidden ${className}`}>
      {buttons.map((item, i) => {
        const isActive = item.type === activeButton;
        return (
          <button
            key={i}
            type='button'
            className={`btn btn-sm ${isActive ? 'btn-primary' : ''}`}
            onClick={onButtonClick.bind(null, item)}
          >
            {item.name}
          </button>
        );
      })}
    </div>
  );
};

export default SwitchButton;
